import React, { useState } from 'react';
import CustomMergeEventGrid from './data/mergeEvent/CustomMergeEventGrid';

const CustomBoardViewer = () => {
    const [jsonInput, setJsonInput] = useState('');
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        setJsonInput(e.target.value);
        setError('');
    };

    const handleConfirm = () => {
        try {
            const parsed = JSON.parse(jsonInput);
            let boardData = parsed[0];
            if (boardData['ActiveMergeEventState'] === undefined) {
                boardData['ActiveMergeEventState'] = parsed[0];
            }
            setData(boardData);
            setError('');
        } catch (e) {
            setError('유효한 JSON 형식이 아닙니다.');
        }
    };

    return (
        <div style={{ display: 'flex', gap: '24px' }}>
            <div style={{ flex: 1 }}>
                <CustomMergeEventGrid mergeEventData={data} />
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <textarea
                    value={jsonInput}
                    onChange={handleInputChange}
                    rows={10}
                    placeholder="여기에 JSON 데이터를 입력하세요"
                    style={{ width: '100%', marginBottom: '8px' }}
                />
                <button onClick={handleConfirm}>확인</button>
                {error && <div style={{ color: 'red', marginTop: '8px' }}>{error}</div>}
            </div>
        </div>
    );
};

export default CustomBoardViewer;
